// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".type-switch{display:flex;height:40px;margin-left:10px;font-weight:700;background:#f1f1f4;border-radius:5px}.type-switch__item{display:flex;align-items:center;justify-content:center;padding:8px 16px 6px 16px;font-size:16px;min-width:100px;cursor:pointer;white-space:nowrap}@media(max-width:767px){.type-switch__item{font-size:14px;padding:6px 12px;min-width:auto}}.type-switch__item--active{background:#36134a;color:#fff;border-radius:5px}", ""]);
// Exports
module.exports = exports;
